module.exports = __webpack_public_path__ + "static/media/Tooth_icon_1ac4ad.da76be9b.svg";